<template>
    <div id="dash" class="dash">
        <span style="display:none;"> {{rokyjes}}</span>
        <div class="md-layout md-gutter md-alignment-center">
            <div class="md-layout-item md-medium-size-25 md-small-size-50 md-xsmall-size-100">    <span class="tie"><i class="far fa-heart" style="color: darkred;"></i><span  style="color: darkred;">hodnota</span>Hodnota čoho?</span></div>
            <div class="md-layout-item md-medium-size-25 md-small-size-50 md-xsmall-size-100">    <span class="tie"><i class="fas fa-award" style="color: #2b8b10;"></i><span  style="color: #2b8b10;">hodnota</span>Hodnota čoho?</span></div>
            <div class="md-layout-item md-medium-size-25 md-small-size-50 md-xsmall-size-100 ">    <span class="tie"><i class="far fa-flag" style="color: #31ae7c;"></i><span  style="color: #31ae7c;">hodnota</span>Hodnota čoho?</span></div>
            <div class="md-layout-item md-medium-size-25 md-small-size-50 md-xsmall-size-100 ">    <span class="tie"><i class="fas fa-car" style="color: #c6306d;"></i><span  style="color: #c6306d;">hodnota</span>Hodnota čoho?</span></div>
          </div>
        <div class="md-layout md-gutter md-alignment-center">
            <div class="md-layout-item md-medium-size-50 md-small-sizchartDatae-50 md-xsmall-size-100">    <div class="tiesu">
                  <line-chart :chart-data="datacollection" style="position: relative; display: block; height: 370px "></line-chart>
            </div></div>
            <div class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100">    <span class="tiesu">
                <span class="nadl"> <md-progress-bar md-mode="indeterminate" class="loadds" v-if="nacitane"></md-progress-bar></span>
                <i class="fas fa-frog"></i> Upozornenia od posledného prihlásenia - {{lastlogine}} <i class="fas fa-sync-alt refresh" v-on:click="poslednepri()" @mouseover="isHovering = true"  @mouseout="isHovering = false" :class="{'fa-spin': isHovering}"></i>
                <span class="obsahs">
                    <span v-for="upoyornenie in  upoyornenia" :class="upoyornenie[3]"  ><span class="dat"><i class="far fa-calendar-alt"></i> {{upoyornenie[0]}}</span><i class="far fa-user"></i> {{upoyornenie[1]}}<br/>{{upoyornenie[2]}}</span>
                <span class="ziadnevysledky" v-if="niejevzs"><i class="fas fa-search"></i> .. nič nové</span>
                </span>
            </span></div>
        </div>
    </div>

</template>

<script>

import {mapState,mapGetters} from 'vuex';
import LineChart from './graf.vue';
import store from "../store";

    export default {
        name: "App",
        computed:{
            ...mapState([
                'rokysu'
            ]),
            ...mapGetters([
                'rokyjes'
            ])
        },
        components: {
            LineChart
        },
        data(){
            return{
                datacollection: null,
                datasu:'',
                rok:'',
                upoyornenia:'',
                nacitane:true,
                isHovering: false,
                niejevzs: false,
                lastlogine:this.$localStorage.get("lastlogine"),
                name: 'ProgressBarIndeterminate'
            }
        },
     mounted () {
            this.fillData();
            this.poslednepri();
         console.log('mounted');
        },


       methods:{
           fillData () {
               var rok = store.getters.rokyjes;
               console.log(store.getters.grafje[rok][0]);
               this.datacollection = {

                   labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
                   datasets: [
                       {
                           label: 'Tržby',
                           borderColor: '#f87979',
                           data: store.getters.grafje[rok][0]
                       },
                       {
                           label: 'Počet prepravených',
                           borderColor: '#77f898',
                           data: store.getters.grafje[rok][1]
                       }]
               }
           },
           poslednepri(){
               let self = this;
               self.niejevzs = false;
               self.nacitane = true,
               this.$http.post('//adminli.limousintravel.eu/api/odposledneho.php',  { rok:this.$localStorage.get("lastlogin")}).then(function (response) {

                   self.upoyornenia = response.data;
                 self.nacitane = false;
                   if(response.data.length == 0){
                       self.niejevzs = true;
                   }

               });


           }
           },
        beforeCreate() {
            console.log('beforeCreate');
                },
        beforeUpdate() {
            this.fillData();
            console.log('beforeUpdate');
        }
        };

</script>

<style scoped lang="scss" >



    #dash{
        margin: 50px 0 0 250px;
        overflow-y: auto;
        padding: 10px;
        overflow: hidden;

        .md-progress-bar {
            margin: 24px;
        }

        .tiesu{
            box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
            display: block;
            margin: 18px 10px;
            padding: 25px;
           height: 400px;
            position: relative;
            .nadl{
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 10px;
                border-radius: 5px;
                overflow: hidden;

            .loadds{
                margin: 0px;
                background-color: #e1e1e1;
            }
        }
            .refresh{
                float: right;
                cursor:pointer;
            }

            .obsahs{
                height: 100%;
                overflow-y: auto;
                overflow-x: hidden;
                display: block;

                .ziadnevysledky{
                    font-size: 35px;
                    color: #e1e1e1;
                    text-align: center;
                    display: block;
                    margin-top: 97px;
                }
                .ziadnevysledky i{
                    font-size: 62px;
                    display: block;
                    padding-bottom: 17px;
                }

                .warn {
                    background: #ffb648;
                    border-left-color: #f48a06;
                    display: block;
                    color: white;
                    padding: 10px;
                    border-radius: 10px;
                    margin: 15px 0;
                    border-left: 5px solid #f48a06;
                    .dat{
                        display: block;
                    }
                }

                .error {
                    background: #E54D42;
                    display: block;
                    color: white;
                    padding: 10px;
                    border-radius: 10px;
                    margin: 15px 0;
                    border-left: 5px solid #b82e24;
                    .dat{
                        display: block;
                    }
                }
                .success{
                    background: #68cd86;
                    display: block;
                    color: white;
                    padding: 10px;
                    border-radius: 10px;
                    margin: 15px 0;
                    border-left: 5px solid #42a85f;
                    .dat{
                        display: block;
                    }
                }
            }

        }

        .tie{
            box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
            display: block;
            margin: 18px 10px;
            padding: 25px;

            i{
                float: left;
                font-size: 50px;
                margin-right: 10px;
                opacity: .5;
            }
            span{
                display: block;
                font-size: 18px;
                font-weight: 700;
            }
        }

    }
    </style>
